<template>
  <div>
    <div class="columns">
      <div v-if="this.url_moderateur" style="margin:20px auto;">
        <ExportCSVButton :url_moderateur="this.url_moderateur" />
      </div>
      <div style="margin:20px auto;">
        <ExportPDFButton :rowIndex="rowIndex" />
      </div>
    </div>
    <div class="hide-element">
      <AllResultats v-if="modalExportExcelPdf.cardList" />
    </div>
  </div>
</template>

<script>
import ExportCSVButton from '@/components/button/ExportCSVButton'
import ExportPDFButton from '@/components/button/ExportPDFButton'
import AllResultats from '@/components/resultats/AllResultats'
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    ExportCSVButton,
    ExportPDFButton,
    AllResultats
  },
  props: {
    sondage_id: Number,
    url_moderateur: String,
    rowIndex: Number,
    cardList: Boolean
  },
  created () {
    // On recupère tous les résultats du sondage
    this.getResultats({
      urlmoderateur: this.url_moderateur,
      idSondage: this.sondage_id
    })
  },
  beforeDestroy () {
    // if the client download the results's pdf, we not unload the results to show again the results side Client's results
    if (this.modalExportExcelPdf.cardList) this.unload_resultats()
  },
  computed: {
    ...mapGetters(['modalExportExcelPdf'])
  },
  methods: {
    ...mapMutations({
      unload_resultats: 'UNLOAD_RESULTATS'
    }),
    ...mapActions({
      getResultats: 'getResultats'
    })
  }
}
</script>

<style scoped>
.hide-element {
  position: absolute;
  height: auto;
  width: 1200px;
  right: 0;
  top: 0px;
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/sondage/components/Export.vue